import { siteConfig } from "../config/site.js";

// The archived package blocked missing video URLs globally. Keep the behavior local to video components.
export function ArchivedVideo(props) {
  const available =
    !siteConfig.localVideoOnly ||
    siteConfig.availableVideos.includes(
      String(props.src ?? "").replace(/^\//, ""),
    );
  if (available) return <video {...props} />;
  return (
    <video
      {...props}
      src={undefined}
      autoPlay={false}
      preload="none"
      poster={props.poster || siteConfig.videoPlaceholder}
      data-offline-placeholder="1"
      aria-label="视频占位，未打包视频资源"
    />
  );
}
